import React from 'react';
import '../constants/AssetsCss';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import GetORPostAsync from '../constants/restservice';
import withRouter from '../constants/withRouter';

class LevelBonus extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            sponsorBonusTable : ""
        }
    }
    componentDidMount(){
        this.getLevelBonus();
    }
    async getLevelBonus() {
        let res = await GetORPostAsync("GetLevelBonusReport.asp","GET",null,localStorage.getItem("token"));
        if(res.status === "error"){
            if(res.message === "Session Expired"){
                toast(res.message);
                this.props.history.push({
                    pathname:"/"
                });
            }
            this.setState({sponsorBonusTable:"<tr><td colSpan='4'>No Records</td></tr>"});            
            return;
        }
        let str ="";
        for(let i=0;i<res.items.length;i++){
            str += '<tr><td class="bg-color-1 text-white">'+(i+1)+'</td><td>'+res.items[i].date+'</td><td>'+res.items[i].cashwallet+'</td><td>'+res.items[i].package+'</td></tr>';    
            if(i === res.items.length - 1){
                this.setState({sponsorBonusTable:str});
            }
        }
    }
    render() {
        return (<div><div className="page-header">
            <div className="page-leftheader">
                <h4 className="page-title mb-0">Hi! {localStorage.getItem('fullname')}</h4>
            </div>
        </div>
            <div className="row">
                <div className="col-xl-12 col-lg-12 col-md-12">
                    <div className="card">
                        <div className="card-header">
                            <h3 className="card-title text-color-3" style={{fontWeight:"200",fontSize:"22px"}}>Level Bonus Statement</h3>                            
                        </div>
                        <div className="card-body">
                            <div className="table-responsive">
                                <table style={{textAlign:"center"}} className="table table-vcenter text-nowrap mb-0 table-striped table-bordered border-top">
                                    <thead className="">
                                        <tr>
                                            <th>S.No</th>
                                            <th>Date</th>
                                            <th>Amount</th>
                                            <th>Package</th>
                                        </tr>
                                    </thead>
                                    <tbody dangerouslySetInnerHTML={{__html:this.state.sponsorBonusTable}}>
                                       
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        );
    }
}

export default  withRouter(LevelBonus);